module.exports = new __parcel__URL__("gray-icon.0b2164b9.png").toString();